import type { FormattedMemberReferrals } from '@library/types/members/memberReferrals';
import { MemberReferralsRow } from '@bo-components/members/memberReferrals';

export interface MemberReferralRowsProps {
  memberReferrals: FormattedMemberReferrals;
}

export const MemberReferralRows = ({
  memberReferrals
}: MemberReferralRowsProps) => {
  return (
    <>
      {memberReferrals.map((memberReferral) => (
        <MemberReferralsRow
          key={`member-referral-${memberReferral.referralId}`}
          memberReferral={memberReferral}
        />
      ))}
    </>
  );
};
